import { theme, type ThemeConfig } from 'antd';

export const sitePalette = {
  bg: '#04070d',
  surface: '#0b1220',
  surfaceAlt: '#0d1526',
  text: '#f5f7fb',
  textSecondary: '#97a6bb',
  accent: '#7fa8ff',
  accentSoft: 'rgba(127, 168, 255, 0.12)',
  border: 'rgba(77, 101, 142, 0.26)',
  borderStrong: '#1e2b42',
} as const;

export const siteTheme: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  hashed: false,
  token: {
    fontFamily: "Inter, 'Segoe UI', sans-serif",
    colorPrimary: sitePalette.accent,
    colorInfo: sitePalette.accent,
    colorSuccess: '#56c78d',
    colorWarning: '#e5ac48',
    colorError: '#ff7384',
    colorBgBase: sitePalette.bg,
    colorBgLayout: sitePalette.bg,
    colorBgContainer: sitePalette.surface,
    colorBgElevated: sitePalette.surfaceAlt,
    colorText: sitePalette.text,
    colorTextSecondary: sitePalette.textSecondary,
    colorTextHeading: '#ffffff',
    colorBorder: sitePalette.borderStrong,
    colorBorderSecondary: sitePalette.borderStrong,
    colorSplit: sitePalette.borderStrong,
    borderRadius: 24,
    borderRadiusLG: 28,
    borderRadiusSM: 16,
    boxShadow: 'none',
    boxShadowSecondary: 'none',
  },
  components: {
    Layout: {
      bodyBg: 'transparent',
      headerBg: 'transparent',
      footerBg: 'transparent',
    },
    Button: {
      borderRadius: 999,
      controlHeight: 44,
      controlHeightLG: 50,
      defaultBg: sitePalette.surfaceAlt,
      defaultBorderColor: '#25344d',
      defaultColor: sitePalette.text,
      defaultHoverBg: '#121d33',
      defaultHoverColor: '#ffffff',
      defaultHoverBorderColor: '#314560',
      defaultActiveBg: '#121d33',
      defaultActiveBorderColor: '#314560',
      primaryColor: '#0a1020',
      solidTextColor: '#0a1020',
      defaultShadow: 'none',
      primaryShadow: 'none',
    },
    Tag: {
      defaultBg: sitePalette.surfaceAlt,
      defaultColor: '#d5ddea',
    },
  },
};
